import React, { useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { images } from "utils";
import { Button } from "antd";
import { AuthContext } from "../context/AuthContext";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaGlobe,
} from "react-icons/fa";

const Layout = ({ children }: { children: React.ReactElement }) => {
  const { logout } = useContext(AuthContext)!;
  const navigate = useNavigate();
  const location = useLocation();
  const current = location.pathname;

  const navs = [
    { path: "/", label: "Live Election Results" },
    { path: "/historical", label: "Historical Election Results" },
    { path: "/polling-station", label: "Polling Station Results" },
  ];

  const menus = [
    { path: "/Results", label: "Results" },
    { path: "/settings", label: "Settings" },
  ];

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <div className="flex flex-col min-h-screen">
      {/* Header */}
      <header className="bg-black px-12 flex justify-between items-center text-white">
        {/* Logo */}
        <Link to="/">
          <img
            src={images.Logo}
            alt="Election Analysis Logo"
            className="h-[54px]"
          />
        </Link>

        {/* Navigation Links */}
        <nav className="flex gap-8">
          {navs.map((nav) => (
            <Link
              to={nav.path}
              key={nav.path}
              className={`py-6 cursor-pointer border-b-4 transition-colors duration-300 ${
                current === nav.path
                  ? "border-red-600 text-red-600"
                  : "border-transparent hover:border-red-600 hover:text-red-600"
              }`}
            >
              {nav.label}
            </Link>
          ))}
        </nav>

        {/* Right Side: Contact, Settings, and Logout */}
        <div className="flex gap-8 items-center">
          {menus.map((menu) => (
            <Link
              to={menu.path}
              key={menu.path}
              className={`py-6 cursor-pointer border-b-4 transition-colors duration-300 ${
                current === menu.path
                  ? "border-red-600 text-red-600"
                  : "border-transparent hover:border-red-600 hover:text-red-600"
              }`}
            >
              {menu.label}
            </Link>
          ))}

          <Button
            type="primary"
            onClick={handleLogout}
            className="bg-white text-black border-none"
          >
            Logout
          </Button>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 h-full">{children}</main>

      {/* Footer */}
      <footer className="bg-gradient-to-r from-black to-red-600 px-8 py-4 text-white">
        <div className="container mx-auto flex flex-col md:flex-row justify-between items-center">
          {/* Address */}
          <div className="mb-3 md:mb-0 text-center md:text-left">
            <p className="text-gray-300 text-sm">
              No3 Belewusi Streets, Airport Residential Area
            </p>
            {/* <p className="text-gray-300 text-sm gap-2">0241699096</p> */}
          </div>

          {/* Social Media Icons */}
          <div className="flex gap-6 mb-3 md:mb-0">
            {/* Replace '#' with your actual social media URLs */}
            <a
              href="/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="hover:text-gray-300"
            >
              <FaFacebookF size={18} />
            </a>
            <a
              href="/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="X (Twitter)"
              className="hover:text-gray-300"
            >
              <FaTwitter size={18} />
            </a>
            <a
              href="/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="hover:text-gray-300"
            >
              <FaInstagram size={18} />
            </a>
            <a
              href="/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="hover:text-gray-300"
            >
              <FaLinkedinIn size={18} />
            </a>
            <a
              href="/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Website"
              className="hover:text-gray-300"
            >
              <FaGlobe size={18} />
            </a>
          </div>

          {/* Links */}
          <div className="flex flex-col md:flex-row gap-4 text-center text-sm md:text-right">
            <Link to="/terms" className="hover:text-gray-300">
              Terms and Conditions
            </Link>
            <Link to="/privacy" className="hover:text-gray-300">
              Privacy Policy
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
